<template>
  <div>
    <q-select
      v-model="formControlType"
      class="col"
      :options="$mh.asOptions(TEXT_FIELD_TYPES)"
      map-options
      emit-value
      clearable
      :label="`${isTextField ? 'Text' : 'Select'} Field Type`"
      data-test-id="form-control-style-editor"
    />
    <q-checkbox
      v-if="formControlType !== TEXT_FIELD_TYPES.UNDERLINE"
      v-model="formControlOutlined"
      class="col"
      :label="`Outlined ${isTextField ? 'Text' : 'Select'} Fields`"
      bottom-slots
    />
  </div>
</template>

<script>
import { TEXT_FIELD_TYPES } from 'src/models/page/Section'

export default {
  name: 'FormControlStyleEditor',
  props: {
    isTextField: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldType: {
      type: String,
      required: false,
      default: TEXT_FIELD_TYPES.OUTLINED
    },
    fieldOutlined: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      formControlType: this.fieldType,
      formControlOutlined: this.fieldOutlined
    }
  },
  watch: {
    formControlType () {
      this.emitValues()
    },
    formControlOutlined () {
      this.emitValues()
    },
    fieldType () {
      this.formControlType = this.fieldType
    },
    fieldOutlined () {
      this.formControlOutlined = this.fieldOutlined
    }
  },
  created () {
    _.extend(this, {
      TEXT_FIELD_TYPES
    })
  },
  methods: {
    emitValues () {
      this.$emit('update:model-value', this.formControlType, this.formControlOutlined)
    }
  }
}
</script>
